import React from 'react';

interface CanvasLinkProps {
  canvasId: string;
  children?: React.ReactNode;
  className?: string;
}

const CanvasLink: React.FC<CanvasLinkProps> = ({ canvasId, children, className = '' }) => {
  const handleCanvasClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const canvasUrl = `/canvas/${canvasId}`;
    window.open(canvasUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <a
      href={`/canvas/${canvasId}`}
      onClick={handleCanvasClick}
      className={`text-blue-600 hover:text-blue-800 underline cursor-pointer ${className}`}
      title={`Open Canvas: ${canvasId}`}
    >
      {children || `Canvas: ${canvasId}`}
    </a>
  );
};

export default CanvasLink;
